import FormContext from 'root/main/components/forms/core/formContext';
import FormController from 'root/main/components/forms/core/formController';
import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import { FormGTMObjectConstructor } from 'root/utils/tracking/GA4/formTracking';

function initializeForm(formEl) {
    const context = new FormContext();
    context.setForm(formEl);
    const ctl = new FormController(context);
    //init
    ctl.init();
}

/* this is will be dynamically imported on DOMContentLoaded */
/* as well as on the lightbox initialization */
export default function FormControllerInit(el) {
    /* is el a button or a form? if form then this has been called in the lightbox which has only one form */
    if (el && el.tagName === 'FORM') {
        initializeForm(el);
    } else {
        /* this initialization is for forms that are not in lightboxes except for the emailOnly form */
        if (el.length > 0) {
            Array.prototype.forEach.call(el, btn => {
                // exclude running initialization on the consent panel submit buttons
                if (btn.tagName === 'BUTTON' && !btn.dataset.formPartnerResellConsent) {
                    const form = btn.closest('form');
                    initializeForm(form);
                    gtm.form(form).sendEvent('in-page');
                    const formGTMObjectConstructor = new FormGTMObjectConstructor(form);
                    GoogleTagManager.sendEvent(
                        formGTMObjectConstructor.getFormGTMObject('form_in_page')
                    );
                }
            });
        }
    }
}
